import React, { useState, useEffect } from 'react'
// import Avatar from '../Images/safetyPolice.png'
import Footer from '../Component/Footer'
import axios from 'axios'


const BASE_URL = "http://192.168.1.116:9001";



const resolveSrc = (value, fallback = null) => {
  if (!value) return fallback;
  if (typeof value === "string") return value.startsWith("http") ? value : `${BASE_URL}/${value}`;
  return fallback;
};

const FALLBACK_DATA = {
  hero: {
    heading: <>CORPORATE <br /> QHSE <span className="highlight">POLICY.</span></>,
  },
  intro: {
    heading: "We are committed to continual improvement of its HSE performance with the aim of reducing all its HSE risks to a level as low as Reasonably Practicable.",
    paragraphs: [
      "The long-term business success of JEYSHAWN ENGINEERING LIMITED depends on our ability to continually improve the quality and value of our products and services in order to enhance customer satisfaction while protecting people and the environment.",
      "Emphasis is placed on ensuring human health, operations safety, environmental protection, quality enhancement and community goodwill.",
      "JEYSHAWN ENGINEERING LIMITED strives to improve its infrastructure to consistently deliver products and services that exceed customer and applicable statutory and regulatory requirements wherever we operate. We are guided by our core principles of integrity, engagement, innovation and performance.",
      "Our priorities are:",
      "JEYSHAWN ENGINEERING LIMITED improves the infrastructure to consistently deliver products and services that meet customer and applicable statutory and regulatory requirements wherever we operate. We are guided by our principles of integrity, engagement, innovation and performance.",
    ],
  },
  qhseGoals: {
    heading: "QHSE goals",
    paragraphs: [
      "Demonstrate personal commitment to the highest policy as we strive for zero workplace HSE injuries, increased environmental incidents and quality defects.",
      "Provide our work environment that promotes employee engagement, satisfaction and wellbeing.",
      "Actively lead ways to eliminate or minimize identified HSE risks, service and product risks, workplace hazards, process inefficiencies, process variance and the prevention of pollution associated with our products and services.",
      "Drive customer satisfaction with our products, services and solutions, aimed at building long-term loyalty by partnering with customers to achieve mutual success.",
      "Actively seek ways to eliminate or minimize identified HSE risks, service and product risks, workplace hazards, process inefficiencies, process variance and the prevention of pollution associated with our products and services.",
    ],
  },
};

const SafetyPolicy = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${BASE_URL}/api/safety`);
        const payload = data?.data ?? data;
        console.log("SafetyPolicy pageData:", payload);
        setPageData(payload);
        console.log("Get Data", payload)
      } catch (err) {
        console.error("Failed to fetch safety policy data:", err);
      } finally {
        setTimeout(() => setLoading(false), 400);
      }
    };
    fetchData();
  }, []);

  // ── Derived values ──
  const hero      = pageData?.hero      || {};
  const intro     = pageData?.intro     || {};
  const qhseGoals = pageData?.qhseGoals || {};

  const introParagraphs = intro.paragraphs
    ? (Array.isArray(intro.paragraphs)
        ? intro.paragraphs
        : intro.paragraphs.split("\n").filter((p) => p.trim() !== ""))
    : FALLBACK_DATA.intro.paragraphs;

  const goalsParagraphs = qhseGoals.paragraphs
    ? (Array.isArray(qhseGoals.paragraphs)
        ? qhseGoals.paragraphs
        : qhseGoals.paragraphs.split("\n").filter((p) => p.trim() !== ""))
    : FALLBACK_DATA.qhseGoals.paragraphs;

  // ── Loading screen ──
  if (loading) {
    return (
      <div style={{
        position: "fixed", inset: 0,
        background: "#0a0a0a",
        display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        zIndex: 9999,
      }}>
        <div style={{
          width: "48px", height: "48px",
          border: "3px solid rgba(255,255,255,0.1)",
          borderTop: "3px solid #ffffff",
          borderRadius: "50%",
          animation: "spin 0.8s linear infinite",
          marginBottom: "20px",
        }} />
        <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "13px", letterSpacing: "0.1em", textTransform: "uppercase" }}>
          Loading
        </p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <div>
      <div className="container">
        <div className="content-wrapper">
          <div className="text-section">
            <p className="aboutusId wow animate__animated animate__fadeInUp">
              <span className="aboutusId-link">About Us</span>
              <span className="separator">{">"}</span>
              <span className="aboutusId-link active">Safety Policy</span>
            </p>

            <h1 className="main-heading wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
              {hero.title
                ? hero.title
                : <>CORPORATE <br /> QHSE <span className="highlight">POLICY.</span></>}
            </h1>
          </div>
        </div>

        <div className="image-section wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
          <div className="slant-overlay"></div>
          <img
            src={resolveSrc(hero.image)}
            alt="Construction workers operating heavy machinery"
            className="background-image"
          />
        </div>
      </div>

      <div className="safetyPolicy_text">
        <h2 className="wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
          {intro.heading || FALLBACK_DATA.intro.heading}
        </h2>

        {introParagraphs.map((para, i) => (
          <p key={i} className="wow animate__animated animate__fadeInUp" data-wow-delay={`${0.3 + i * 0.1}s`}>
            {para}
          </p>
        ))}

        <h2 className="safetyPolicy_title wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
          {qhseGoals.heading || FALLBACK_DATA.qhseGoals.heading}
        </h2>

        {goalsParagraphs.map((para, i) => (
          <p key={i} className="wow animate__animated animate__fadeInUp" data-wow-delay={`${0.3 + i * 0.1}s`}>
            {para}
          </p>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default SafetyPolicy;